"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSortArray = exports.SortArrayProvider = exports.DEFAULT_PLAYERS_SORT_ARRAY = void 0;
var q_play_core_1 = require("@nordicscreen/q-play-core");
var react_1 = __importStar(require("react"));
var react_admin_1 = require("react-admin");
var SORT_ARRAY_LOCAL_STORAGE_KEY = "players.sortArray";
exports.DEFAULT_PLAYERS_SORT_ARRAY = ["player_groups.name", react_admin_1.SORT_ASC, "name", react_admin_1.SORT_ASC];
var defaultSortArrayContext = {
    sortArray: localStorage.getItem(SORT_ARRAY_LOCAL_STORAGE_KEY) ?
        JSON.parse(localStorage.getItem(SORT_ARRAY_LOCAL_STORAGE_KEY))
        :
            exports.DEFAULT_PLAYERS_SORT_ARRAY,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    updateSortArray: function (_sortArray) {
        return undefined;
    }
};
var SortArrayContext = (0, react_1.createContext)(defaultSortArrayContext);
var SortArrayProvider = function (_a) {
    var children = _a.children;
    var logger = q_play_core_1.logManager.getLogger();
    var _b = (0, react_1.useState)(localStorage.getItem(SORT_ARRAY_LOCAL_STORAGE_KEY) ?
        JSON.parse(localStorage.getItem(SORT_ARRAY_LOCAL_STORAGE_KEY))
        :
            exports.DEFAULT_PLAYERS_SORT_ARRAY), sortArray = _b[0], setSortArray = _b[1];
    var updateSortArray = (0, react_1.useCallback)(function (newSortArray) {
        setSortArray(newSortArray);
        try {
            localStorage.setItem(SORT_ARRAY_LOCAL_STORAGE_KEY, JSON.stringify(newSortArray));
        }
        catch (e) {
            logger.error("Saving sorting for players in local storage failed.", e);
        }
    }, []);
    return (react_1.default.createElement(SortArrayContext.Provider, { value: { sortArray: sortArray, updateSortArray: updateSortArray } }, children));
};
exports.SortArrayProvider = SortArrayProvider;
var useSortArray = function () {
    var context = (0, react_1.useContext)(SortArrayContext);
    if (!context) {
        throw new Error("useSortArray must be used within a SortArrayProvider");
    }
    return context;
};
exports.useSortArray = useSortArray;
